import moment from 'moment'

const Status = {
  LOADING: 'loading',
  SUCCESS: 'success',
  FAILURE: 'failure'
}

function isPC() {
  const userAgentInfo = navigator.userAgent
  const Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"]
  let flag = true
  for(let v = 0; v < Agents.length; v++) {
    if(userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false
      break
    }
  }
  return flag
}

const checkTime = () => (
  ((moment().unix() - localStorage.getItem('ShadowFog_timestamp')) < 6 * 3600 ) ? true : false
)


export default (state = {isAuthenticated: checkTime(), isPC: isPC()}, action) => {
  const setStorage = (result) => {
    localStorage.setItem('ShadowFog_token', result.token)
    localStorage.setItem('ShadowFog_userid', result.user_id)
    localStorage.setItem('ShadowFog_username', result.username)
    localStorage.setItem('ShadowFog_timestamp', moment().unix())
  }
  switch(action.type) {
    case 'AUTH/LOGOUT': {
      localStorage.clear()
      return {...state, isAuthenticated: false}
    }
    case 'AUTH/LOGIN_STARTED': {
      return {...state, loginStatus: Status.SUCCESS, isAuthenticated: false}
    }
    case 'AUTH/LOGIN_SUCCESS': {
      setStorage(action.result)
      return {...state, isAuthenticated: true}
    }
    case 'AUTH/LOGIN_FAILURE': {
      return {...state, loginStatus: Status.FAILURE, isAuthenticated: false}
    }
    case 'AUTH/SIGNUP_STARTED': {
      return {...state, signupStatus: Status.LOADING};
    }
    case 'AUTH/SIGNUP_SUCCESS': {
      return {...state, signupStatus: Status.SUCCESS, isAuthenticated: false};
    }
    case 'AUTH/SIGNUP_FAILURE': {
      return {...state, signupStatus: Status.FAILURE};
    }
    case 'AUTH/FORGET_STARTED': {
      return {...state, forgetStatus: Status.LOADING};
    }
    case 'AUTH/FORGET_SUCCESS': {
      return {...state, forgetStatus: Status.SUCCESS};
    }
    case 'AUTH/FORGET_FAILURE': {
      return {...state, forgetStatus: Status.FAILURE};
    }
    default: {
      return state
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/auth/reducer.js